/**
 * Where the phone planner opens (#828).
 *
 * The days already over are drawn above today, not folded into a « N jours
 * passés » row that sat first on the page. So the list does not open at its
 * top: it opens on the next meal, and the past is a scroll up.
 *
 *   - `lead`  — the hero (today's next meal) or whatever is said about tonight
 *               (« Des restes ? »), drawn right above today;
 *   - `day`   — with nothing to say about today, today's own day; once tonight
 *               is over (21:00, the generator's cutoff), tomorrow;
 *   - `null`  — today is not in the list (a page of history): the top.
 *
 * Never before today. Pure so it can be tested without a renderer.
 */
import { addDays } from '../../../utils/localDate';
import { TONIGHT_CUTOFF_MINUTES } from '../../meal-config/useGenerateWeek';

export type PlannerOpening = { kind: 'lead' } | { kind: 'day'; iso: string };

export function plannerOpening({
  today,
  nowMinutes,
  hasLead,
  todayDrawn,
}: {
  today: string;
  nowMinutes: number;
  /** Something is drawn above today: the hero, or a prompt about tonight. */
  hasLead: boolean;
  /** Today is inside one of the weeks the list stacks. */
  todayDrawn: boolean;
}): PlannerOpening | null {
  if (!todayDrawn) return null;
  if (hasLead) return { kind: 'lead' };
  return { kind: 'day', iso: nowMinutes >= TONIGHT_CUTOFF_MINUTES ? addDays(today, 1) : today };
}
